module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [(_vm.row.score_status == 3) ? _c('div', {
    staticClass: "danwei-warp"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.row.danwei))]), _vm._v(" "), _vm._l((_vm.row.price_list), function(item, index) {
    return _c('div', {
      staticClass: "saiqu"
    }, [_c('div', [_vm._v(_vm._s(item.grade) + "星级：" + _vm._s(item.total) + "人")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.total) + "*" + _vm._s(item.price) + "=" + _vm._s(item.total * item.price) + "元")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("总计：" + _vm._s(_vm.row.order_price) + "元")])], 2) : _c('div', {
    staticClass: "danwei-warp"
  }, [(_vm.row.members > 0) ? _c('div', {
    staticClass: "danwei-people",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('van-button', {
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
    },
    on: {
      "click": function($event) {
        return _vm.action(1)
      }
    }
  }, [_vm._v("已报名" + _vm._s(_vm.row.members) + "人，点击查看")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.row.danwei))]), _vm._v(" "), _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("考试时间：" + _vm._s(_vm.row.datetitle))]), _vm._v(" "), (_vm.row.sai_baoming_id == 0) ? _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("报名截止时间：" + _vm._s(_vm.row.baoming_enddate))]) : _vm._e(), _vm._v(" "), (_vm.row.sai_baoming_id > 0) ? _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("赛场考级队伍：" + _vm._s(_vm.row.sai_baoming_name))]) : _vm._e(), _vm._v(" "), (_vm.row.sai_baoming_id > 0) ? _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("赛场考级项目：" + _vm._s(_vm.row.sai_baoming_subject_name))]) : _vm._e(), _vm._v(" "), (_vm.row.sai_baoming_id > 0) ? _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("赛场考级赛区：" + _vm._s(_vm.row.sai_baoming_saiqu_name))]) : _vm._e(), _vm._v(" "), (_vm.starText) ? _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("本次考试星级：" + _vm._s(_vm.starText))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("考试地点：" + _vm._s(_vm.row.province) + _vm._s(_vm.row.city) + " " + _vm._s(_vm.row.address))]), _vm._v(" "), (_vm.row.phone) ? _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("联系人电话：" + _vm._s(_vm.row.phone))]) : _vm._e(), _vm._v(" "), (_vm.row.zhuyishixiang) ? _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("特殊说明：" + _vm._s(_vm.row.zhuyishixiang))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("考官：\n        "), _vm._l((_vm.row.kaoguan), function(kg, key) {
    return _c('span', {
      key: key
    }, [_c('br'), _vm._v(_vm._s(kg.name) + " " + _vm._s(kg.phone))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "saiqu"
  }, [_vm._v("监督：\n        "), _vm._l((_vm.row.jiandu), function(kg, key) {
    return _c('span', {
      key: key
    }, [_c('br'), _vm._v(_vm._s(kg.name) + " " + _vm._s(kg.phone))])
  })], 2)]), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": function($event) {
        _vm.showWxShare = false
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "position": "fixed",
      "bottom": "80px",
      "left": "10px",
      "width": "2rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.onTemplateShow
    }
  }, [_vm._v("批量导入\n    ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "position": "fixed",
      "bottom": "80px",
      "right": "10px",
      "width": "2rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.onMemberDownload
    }
  }, [_vm._v("数据导出\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.onShare
    }
  }, [_vm._v("\n        分享二维码至微信群\n      ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": function($event) {
        return _vm.action(2)
      }
    }
  }, [_vm._v("\n        手动录入\n      ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": function($event) {
        return _vm.action(3)
      }
    }
  }, [_vm._v("\n        支付费用\n      ")])], 1), _vm._v(" "), _c('van-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "导入模板信息",
      "showCancelButton": true,
      "showConfirmButton": false,
      "confirmButtonText": "导入模板"
    },
    model: {
      value: (_vm.showTemplate),
      callback: function($$v) {
        _vm.showTemplate = $$v
      },
      expression: "showTemplate"
    }
  }, [_c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("复制下面的链接，用电脑端打开，进行批量导入操作")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.template_share),
      expression: "template_share",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "operate-desc-left",
    staticStyle: {
      "color": "#666"
    }
  }, [_vm._v("导入模板链接地址：" + _vm._s(_vm.template_share) + " "), _c('div', {
    staticClass: "small-button"
  }, [_vm._v("复制")])])]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  }, [_c('div', {
    staticClass: "circle-div"
  }, [_c('van-circle', {
    attrs: {
      "stroke-width": 60,
      "color": {
        '0%': '#ffad19',
        '100%': '#fec835',
      },
      "rate": _vm.progress,
      "speed": 100,
      "text": _vm.progress + '%'
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin-top": "10px"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("上传中\n        ")])], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "批量导入错误信息"
    },
    model: {
      value: (_vm.showError),
      callback: function($$v) {
        _vm.showError = $$v
      },
      expression: "showError"
    }
  }, [_c('van-cell-group', _vm._l((_vm.errorMsg), function(item) {
    return _c('van-cell', {
      attrs: {
        "title": item
      }
    })
  }), 1)], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友(朋友圈)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-662d8827","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameApplyDetailMine.vue
// module id = 2453
// module chunks = 0